import { useEffect, useState } from "react";
import { Wrap, WrapItem, Image, Spinner, Text, Box } from "@chakra-ui/react";
import { ethers } from "ethers";
import useInterval from "use-interval";

import BaseLayout from "../templates/BaseLayout";
import { getRefreshTime } from "../utils/consts";
import safeGetParams from "../utils/safeGetParams";

const MAX_COUNT = 100;
const BOX_SIZE = 200;

export default function AllBase({ contractInfo }) {
    const refreshTime = getRefreshTime(contractInfo.network);

    const [contract, setContract] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [items, setItems] = useState([]);

    useInterval(() => {
        console.log("timer", new Date().toLocaleString());
        updateItems();
    }, refreshTime);

    useEffect(() => {
        const provider = new ethers.providers.JsonRpcProvider(contractInfo.rpcUrl);
        const _contract = new ethers.Contract(contractInfo.address, contractInfo.abi, provider); // read only contract
        setContract(_contract);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contract]);

    async function updateItems() {
        if (!contract) return;
        setLoading(true);
        setItems([]);
        setError("");

        const tasks = [];
        try {
            const count = await contract.totalSupply();
            for (let tokenId = count; tokenId >= Math.max(1, count - MAX_COUNT); tokenId--) {
                // const tokenIdBN = await contract.tokenByIndex(i); // HINT: i == tokenId なので省略
                const task = safeGetParams(contract, tokenId).then((params) => {
                    if (params.error) {
                        console.warn("updateItems #", tokenId, params.error);
                    } else {
                        setItems((prev) => prev.concat([{ tokenId, ...params }]));
                    }
                });

                tasks.push(task);
            }
            await Promise.all(tasks);
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    }

    function getTitle(name, age, isAlive) {
        return isAlive ? `${name} (${age} hours old)` : `${name} (Aged ${age} hours)`;
    }

    function sortFunc(a, b) {
        return b.tokenId - a.tokenId;
    }

    return (
        <BaseLayout isHome={false} network={contractInfo.network}>
            <Wrap>
                {items
                    .filter((p) => !p.error) // エラーのアイテムは表示しない
                    .sort(sortFunc)
                    .map(({ tokenId, name, age, isAlive, svg }) => (
                        <WrapItem key={tokenId}>
                            <Image
                                title={getTitle(name, age, isAlive)}
                                boxSize={BOX_SIZE}
                                src={
                                    svg
                                        ? `data:image/svg+xml;charset=utf-8;base64,${Buffer.from(svg).toString(
                                              "base64"
                                          )}`
                                        : ""
                                }
                            />
                        </WrapItem>
                    ))}
            </Wrap>
            {loading && (
                <Box>
                    <Spinner />
                </Box>
            )}
            <Box>
                <Text color="red.500">{error}</Text>
            </Box>
        </BaseLayout>
    );
}
